import { SVGProps } from "react";

const Clock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width || 16}
    height={props.height || 16}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="10.75"
      cy="10.75"
      r="10"
      stroke={props.stroke || "#F0B02A"}
      stroke-width="1.5"
    />
    <path
      d="M10.75 6.75V10.75L12.75 12.75"
      stroke={props.stroke || "#F0B02A"}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export default Clock;
